import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { AdditionalInfoView } from '../../../../redux/additionalInfo/typings';
import { t } from '../../../../strings/i18n/i18n';
import BannerWithText from '../../../../ui/atoms/BannerWithText';
var AdditionalInfoTextBanner = function () {
    var _a = useSelector(function (state) { return state; }), assetsURL = _a.mfeConfig.assetsURL, currentView = _a.additionalInfo.currentView, isLoading = _a.ui.isLoading;
    if (isLoading) {
        return null;
    }
    switch (currentView) {
        case AdditionalInfoView.Upload:
            return (_jsx(BannerWithText, { inlineDesign: true, assetsURL: assetsURL, bannerImage: "CLOUD_FILE", altText: "Add Documents or Comments", content: t('additionalInfo.shortTitle'), paragraphs: [t('additionalInfo.securityDisclaimerReminder')], "data-cy": "additional-information-inline-banner" }));
        case AdditionalInfoView.Review:
            return (_jsx(BannerWithText, { inlineDesign: true, assetsURL: assetsURL, bannerImage: "MAGNIFY", altText: "Add Documents or Comments", content: t('additionalInfo.review'), "data-cy": "additional-information-inline-banner" }));
        case AdditionalInfoView.CancelConfirmation:
        case AdditionalInfoView.SubmitConfirmation:
        case AdditionalInfoView.DeleteConfirmation:
        default:
            return null;
    }
};
export default AdditionalInfoTextBanner;
//# sourceMappingURL=index.js.map